<template lang="html">
  <div>
    <table class="table mb-0 table-striped">
      <thead class="bg-light">
        <tr>
          <th scope="col" class="border-0">#</th>
          <th scope="col" class="border-0">{{ $t('word.importTable.columns.date') }}</th>
          <th scope="col" class="border-0">{{ $t('word.importTable.columns.file') }}</th>
          <th scope="col" class="border-0">{{ $t('word.importTable.columns.user') }}</th>
          <th scope="col" class="border-0">{{ $t('word.importTable.columns.totalRead') }}</th>
          <th scope="col" class="border-0">{{ $t('word.importTable.columns.inserted') }}</th>
          <th scope="col" class="border-0 text-center">{{ $t('word.importTable.columns.options') }}</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(row, index) in imports">
          <tr :key="`row-${index}`">
            <td>{{ row.id }}</td>
            <td>{{ formatDate(row.created_at) }}</td>
            <td>{{ row.file_name || '-' }}</td>
            <td>{{ row.user ? row.user.name : $t('word.importTable.system') }}</td>
            <td>{{ row.total_words }}</td>
            <td class="font-weight-bold">
              {{ row.inserted_words }}
            </td>
            <td class="text-center">
              <button
                type="button"
                class="btn btn-sm text-white"
                :class="isExpanded(row.id) ? 'btn-secondary' : 'btn-info'"
                @click="toggleExpand(row.id)"
                :disabled="
                  !row.imported_words || row.imported_words.length === 0
                "
              >
                <i
                  :class="
                    isExpanded(row.id) ? 'fas fa-chevron-up' : 'fas fa-eye'
                  "
                  class="mr-1"
                />
                {{ isExpanded(row.id) ? $t('word.importTable.hide') : $t('word.importTable.viewWords') }}
              </button>
            </td>
          </tr>

          <tr
            v-if="isExpanded(row.id)"
            :key="'expand-' + index"
            class="bg-light"
          >
            <td colspan="7" class="p-3">
              <div
                class="expanded-words-container border p-3 bg-white shadow-sm"
              >
                <div class="mb-2 text-muted small">
                  <strong>{{ row.inserted_words }}</strong>
                  {{ $t('word.importTable.newWordsImported') }}
                </div>

                <div class="words-scroll">
                  <span
                    v-for="(word, idx) in row.imported_words"
                    :key="idx"
                    class="badge badge-primary m-1"
                    style="font-size: 16px"
                  >
                    {{ word }}
                  </span>
                </div>
              </div>
            </td>
          </tr>
        </template>

        <tr v-if="imports.length === 0">
          <td colspan="7" class="text-center py-4 text-muted">
            {{ $t('word.importTable.noContent') }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'word-import-table',
  props: {
    imports: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      expandedRows: [],
    };
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      const localeMap = { es: 'es-ES', en: 'en-GB', pt: 'pt-BR' };
      const locale = localeMap[this.$i18n.locale] || 'pt-BR';
      return date.toLocaleDateString(locale, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },
    isExpanded(id) {
      return this.expandedRows.includes(id);
    },
    toggleExpand(id) {
      const index = this.expandedRows.indexOf(id);
      if (index > -1) {
        this.expandedRows.splice(index, 1);
      } else {
        this.expandedRows.push(id);
      }
    },
  },
  watch: {
    imports() {
      this.expandedRows = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.expanded-words-container {
  border-radius: 6px;
}

.words-scroll {
  max-height: 250px;
  overflow-y: auto;
}
</style>
